var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6666 6.66667H25.8333L24.1666 5H15.8333L14.1666 6.66667H8.33325V10H31.6666M9.99992 31.6667C9.99992 32.5507 10.3511 33.3986 10.9762 34.0237C11.6014 34.6488 12.4492 35 13.3333 35H26.6666C27.5506 35 28.3985 34.6488 29.0236 34.0237C29.6487 33.3986 29.9999 32.5507 29.9999 31.6667V11.6667H9.99992V31.6667Z",
    fill: "#C1292E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.7e164c293cba93c026121d659dd016f3.svg";
export { ForwardRef as ReactComponent };